import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'reactstrap';

import classnames from 'classnames';
import styles from './index.module.scss';

export class DropdownV2 extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  };

  render() {
    const { isOpen, toggle, direction, className, ...other } = this.props;
    const defaultClasees = classnames(className, styles.dropdown);

    return (
      <Dropdown
        className={defaultClasees}
        isOpen={isOpen}
        toggle={toggle}
        direction={direction}
        {...other}
      />
    );
  }
}

export default DropdownV2;
